import request from "root/js/request";

const getCommissionDiscountTopDetails = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  product_id__in,
  barcode__in,
  subject_id__in,
  spp_prc_discount_group,
}) => {
  const response = await request({
    url: "/analytics/commission_discount_top_details/",

    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      product_id__in,
      barcode__in,
      subject_id__in,
      spp_prc_discount_group,
    },
  });
  return response.data;
};

export { getCommissionDiscountTopDetails };
